export enum InChargeOfEnum {
  SicInternal = 0, // Tecnici interni
  SicContracts = 1, // ELLF
  GlobalService = 2, // Gloobal service
}

export const InChargeOfValues = [
  {
    value: InChargeOfEnum.GlobalService,
    description: 'Global service',
  },
  { value: InChargeOfEnum.SicContracts, description: 'ELLF' },
  { value: InChargeOfEnum.SicInternal, description: 'Tecnici interni' },
];
